import React from 'react';
import { formatCurrency } from '../../utils/currency';

// Currency of a bank row: row → its bank account → caller fallback.
export const rowCurrencyOf = (tx, bankAccounts = [], fallback) =>
  tx?.currency || tx?.bank_currency
  || bankAccounts.find((b) => b.id === tx?.bank_account_id)?.currency
  || fallback;

// "≈ $8.10 @ 1.3530" under a foreign-currency row amount. Renders nothing
// when the row is already in the business's base currency or has no rate.
export const RowFxEquivalent = ({ tx, rowCurrency, baseCurrency, amount = tx?.amount, className = '' }) => {
  const rate = Number(tx?.fx_rate || 0);
  if (!rowCurrency || !baseCurrency || rowCurrency === baseCurrency || !(rate > 0)) return null;
  const base = Math.abs(Number(amount) || 0) * rate;
  return (
    <span
      className={`text-[10px] text-muted-foreground tabular-nums whitespace-nowrap ${className}`}
      data-testid={`row-fx-equiv-${tx?.id}`}
      title={`1 ${rowCurrency} = ${rate.toFixed(4)} ${baseCurrency}`}
    >
      ≈ {formatCurrency(base, baseCurrency)} @ {rate.toFixed(4)}
    </span>
  );
};
